import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

/* MODAL */
import { useModal } from 'hooks/modalContext';
import { confirmAlert } from 'react-confirm-alert';

/* 컴포넌트 */
import ProductSearchForm from 'components/product/ProductSearchForm';

const Status = () => {
  const { openModal } = useModal();

  const [productMstList, setProductMstList] = useState([{
    productSeq: 0,
    fkProductType: '',
    productType: '',
    fkProductKind: '',
    productKind: '',
    fkWarehouse: '',
    warehouse: '',
    productName: '',
    fkProductUnit: '',
    productUnit: '',
    productStatus: '',
    regDate: '',
    defaultQuantity: 0,
    currentQuantity: 0,
  }]);
  const [search, setSearch] = useState({
    productName: '',
    warehouseSeq: '',
    productTypeMstSeq: '',
    productKindSeq: '',
  });

  useEffect(() => {
    Common.isLogin();

    getProductMstList();
  }, []);

  const getProductMstList = () => {
    Server.sendGet('product/mst', search, getProductMstListCallback).then();
  };

  const getProductMstListCallback = res => {
    setProductMstList(res?.['resultList']);
  };

  const changeStatus = item => {
    confirmAlert({
      title: 'Are you sure you want to discard?',
      buttons: [{
        label: 'Yes',
        onClick: () => {

          Server.sendPost('product/status', {
            productSeq: item.productSeq,
            productStatus: 'D',
          }, changeStatusCallback).then();
        }
      }, {
        label: 'No'
      }]
    });
  };

  const changeStatusCallback = () => {
    Common.errorMsg('Discard complete.');

    getProductMstList();
  };

  const handleContent = item => {
    openModal({
      modalName: 'ProductHistoryModal',
      modalData: {
        isRegi: false,
        data: {
          item: item,
          callback: getProductMstList,
        },
      }
    });
  };

  return (
    <>
      <Inner>
        <Title>
          <TitHead>
            <i/>
            <h4>Product Status</h4>
          </TitHead>
        </Title>
        <ProductSearchForm
          search={search}
          setSearch={setSearch}
          getList={getProductMstList}
        />
        <Content>
          <Table>
            <colgroup>
              <col width='10%'/>
              <col width='10%'/>
              <col width='15%'/>
              <col width='15%'/>
              <col width='10%'/>
              <col width='10%'/>
              <col width='10%'/>
              <col width='10%'/>
              <col width='10%'/>
            </colgroup>
            <thead>
            <tr>
              <th>Warehouse</th>
              <th>Product Type</th>
              <th>Product Kind</th>
              <th>Product Name</th>
              <th>Quantity</th>
              <th>Current Quantity</th>
              <th>Unit</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {productMstList?.map((item, idx) => (
              <tr key={idx}>
                <td onClick={() => handleContent(item)}>{item.warehouse}</td>
                <td onClick={() => handleContent(item)}>{item.productType}</td>
                <td onClick={() => handleContent(item)}>{item.productKind}</td>
                <td onClick={() => handleContent(item)}>{item.productName}</td>
                <td onClick={() => handleContent(item)}>{item.defaultQuantity}</td>
                <td onClick={() => handleContent(item)}>{item.currentQuantity}</td>
                <td onClick={() => handleContent(item)}>{item.productUnit}</td>
                <td onClick={() => handleContent(item)}>{item.productStatus}</td>
                <td>
                  {item.productStatus !== 'Discard' &&
                    <TitBtn onClick={() => changeStatus(item)}>
                      <span>discard</span>
                    </TitBtn>
                  }
                </td>
              </tr>
            ))}
            {Common.isEmpty(productMstList) &&
              <tr>
                <td colSpan={9} className={'none-data'}>
                  There is no data to output.
                </td>
              </tr>
            }
            </tbody>
          </Table>
        </Content>
      </Inner>
    </>
  );
}

const Inner = styled.div`
  flex: 1;
  background: #ffffff;
`;

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
`;

const Content = styled.div`
  margin-top: 35px;
  position: relative;
  height: 622px;
  overflow-y: scroll;
`;

const Table = styled.table`
  position: relative;

  & th {
    padding: 15px 0;
    font-weight: 400;
    font-size: 18px;
    color: #777777;
    background: #f8f8f8;
    text-align: center;
    border-bottom: 1px solid #eeeeee;
    vertical-align: middle;
  }

  & td {
    padding: 10px 0;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    text-align: center;
    vertical-align: middle;
    border-bottom: 1px solid #eeeeee;
    border-left: 1px solid #eeeeee;
    height: 47px;
  }

  & thead {
    position: sticky;
    top: 0;
  }

  & tbody > tr {
    cursor: pointer;

    &:hover {
      & td {
        background: #f4f4f4;
      }
    }
  }

  & tr td.none-data {
    height: 572px;
    border: 0;
  }

  & tr td:first-child {
    border-left: none;
  }

  & tr:nth-child(even) {
    background: #fcfcfc;
  }
`;

const TitBtn = styled.button`
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  gap: 0 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  border-radius: 5px;
  margin: auto;

  & span {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default Status;